<template>
    <div class="page">

        <img class="logo" src="../assets/logo.png">

        <div class="unsub-text" style="text-align: center;color: black">  {{ msg }}</div>
        <div @click="goto" class="btn btn-blue btn-block">စာရင်းသွင်းခြင်း။</div>
    </div>
</template>

<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Error',
    components: {answerHeader},
    data(){
        return {
          msg:'',
        }
    },
    computed: {
        ...mapState(['lang','langMap'])
    },
    created(){
      let msg = this.$route.query.msg
      if(msg){
        this.msg = msg
      }
    },
    methods: {
      goto() {
        this.$router.push('login');
      }
    }
}
</script>

<style lang="scss" scoped>
    .page{
        color: #fff;
    }
    .fz46{
        font-size: rem(46);
    }
    .unsub-text{
        margin: rem(60) auto rem(30);
        height: rem(550);
        overflow-y: scroll;
        p{
            margin: rem(20) 0;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/error.vue